import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    // AttendanceViewMode_WEEK (1) specifies that the person's default view mode
    // should be the week view.
    { value: 1, label: 'Week' },

    // AttendanceViewMode_PERIOD (2) specifies that the person's default view mode
    // should be the period view.
    { value: 2, label: 'Period' },
  ],
});
